import React from 'react'
import { TRUST_CHECKLIST } from '../data/venues'
import { useScrollReveal } from '../hooks/useScrollReveal'

const CHECK_ICON = 'M20 6 9 17l-5-5'

const TrustSection: React.FC = () => {
  const { ref, visible } = useScrollReveal<HTMLDivElement>()

  return (
    <section id="trust" className="v2-section v2-section--trust">
      <div ref={ref} className={`v2-container v2-reveal ${visible ? 'is-visible' : ''}`}>
        <h2 className="v2-section-title v2-section-title--center">
          Trust &amp; <em className="v2-em-mint">privacy</em>
        </h2>

        <div className="v2-trust-grid">
          <div className="v2-trust-copy">
            <h3>
              Know when you’re <em className="v2-em-mint">visible.</em>
            </h3>
            <p>Meeting someone starts with knowing how the app works.</p>
            <p>Before you check in, the map shows a count. Names and photos stay hidden.</p>
            <p>Check in to see profiles at the same location. Check out when you’re ready to leave.</p>
          </div>

          <div>
            <h3>
              Your check-in, <em className="v2-em-mint">explained.</em>
            </h3>
            <ul className="v2-checklist">
              {TRUST_CHECKLIST.map(item => (
                <li key={item}>
                  <svg aria-hidden="true" viewBox="0 0 24 24" width={24} height={24} fill="none" stroke="#3F8A60" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round">
                    <path d={CHECK_ICON} />
                  </svg>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TrustSection
